if ($('.compare-icon').length > 0) {
  if ($(window).innerWidth() < 768) {
    $('.compare-drop').prependTo('.nav-collapse');
  }
}
